import { useTenantStore } from '../stores/useTenantStore';

interface FetchWithAuthOptions extends RequestInit {
  skipTokenRenewal?: boolean;
}

/**
 * Wrapper autour de fetch qui injecte le Bearer token.
 * Le renouvellement silencieux est géré automatiquement par oidc-client-ts (automaticSilentRenew).
 * En cas de 401, le store est réinitialisé pour forcer une reconnexion.
 */
export const fetchWithAuth = async (
  url: string,
  options: FetchWithAuthOptions = {}
): Promise<Response> => {
  const { skipTokenRenewal, ...fetchOptions } = options;

  const idToken = useTenantStore.getState().getIdToken();

  if (!idToken && !skipTokenRenewal) {
    throw new Error('No authentication token available. Please log in.');
  }

  const headers = new Headers(fetchOptions.headers);
  if (idToken) {
    headers.set('Authorization', `Bearer ${idToken}`);
  }
  if (!headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  const response = await fetch(url, { ...fetchOptions, headers });

  if (response.status === 401 && !skipTokenRenewal) {
    useTenantStore.getState().reset();
    throw new Error('Session expirée. Veuillez vous reconnecter.');
  }

  return response;
};
